<div class="multipatient" [ngClass]="theme" *ngIf="vars?.fundraiser?.is_multi_patient_campaign">
  <div class="text">Raised for {{vars?.fundraiser?.beneficiaryname?.info_1?.split(' ')[0]}} and other patients in need </div>
  <em class="material-icons">info</em>
  <span class="tooltiptext">
    <div class="header">For {{vars?.fundraiser?.beneficiaryname?.info_1?.split(' ')[0]}} or other patients in need</div>
    <div class="horizontalline"></div>
    <div class="sub">Today’s a special day! Your donation right now can help {{vars?.fundraiser?.beneficiaryname?.info_1?.split(' ')[0]}} or others fighting a similar emergency. This is truly a remarkable deed, thank you!</div>
  </span>
</div>